import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Heart } from "lucide-react";
import { StoreLayout } from "@/components/StoreLayout";
import { ProductCard } from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const container = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.05 } } };

export default function Wishlist() {
  const navigate = useNavigate();
  const { shopLoggedIn, wishlistIds } = useAuth();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try { const { data } = await api.get("/wishlist"); setProducts(data.products); } finally { setLoading(false); }
  };
  useEffect(() => {
    if (!shopLoggedIn) { navigate("/login"); return; }
    load();
    // eslint-disable-next-line
  }, [wishlistIds.length]);

  return (
    <StoreLayout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="font-display text-3xl mb-6">Your Wishlist</h1>
        {loading ? <div className="py-24 text-center text-muted-foreground">Loading...</div>
          : products.length === 0 ? (
          <div className="py-24 text-center">
            <Heart className="h-12 w-12 mx-auto text-muted-foreground/40 mb-4" />
            <p className="text-muted-foreground">No saved items yet.</p>
            <Button className="mt-4" onClick={() => navigate("/products")}>Explore jewellery</Button>
          </div>
        ) : (
          <motion.div variants={container} initial="hidden" animate="show" data-testid="wishlist-grid" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
            {products.map((p) => <div key={p.id} data-testid="wishlist-item"><ProductCard product={p} /></div>)}
          </motion.div>
        )}
      </div>
    </StoreLayout>
  );
}
